import * as Sentry from '@sentry/browser';
import ProductHeaderInterface from '../interfaces/ProductHeaderInterface';
import DeleteProductService from '../../../Cart/Services/DeleteProductService';
import ListCartHeaderInterface from '../interfaces/ListCartHeaderInterface';
import formatListCartHeader from '../../../../shared/helpers/formatListCartHeader';
import sendEventTracking from '../../../../Services/Tracking/TrackingGoogle/Events/sendEventTracking';

/**
 * Cart Header services.
 */
export default class CartHeaderServices {
  static logSentry = 0;

  /*
   * Delete product in cart
   * */
  public static async deleteProduct(
    referenceId: string,
    element: HTMLElement,
    deleteCallback: Function,
    productElement: HTMLElement
  ) {
    const classLocked = 'is-lockedDeleteId';

    if (!element.classList.contains(classLocked)) {
      element.classList.add(classLocked);

      // Add Overlay to element deleted
      productElement.classList.add('is-awaitDelete');

      const response = await DeleteProductService.deleteProduct(referenceId);

      if (response) {
        const listProducts: ListCartHeaderInterface = response.cart
          ? formatListCartHeader(
              response.cart.items,
              response.cart.formattedTotal,
              response.cart.total
            )
          : {};

        const dataLayer: any = window.dataLayer || [];

        sendEventTracking({
          event: 'remove_from_cart',
          dataLayer,
          ecommerce: {
            currency: response.cartDiff.currency,
            value: response.cartDiff.total,
            items: [
              {
                item_id: response.cartDiff.items[0].id,
                item_name: response.cartDiff.items[0].name,
                item_category: response.cartDiff.items[0].category,
                price: response.cartDiff.items[0].price,
                quantity: response.cartDiff.items[0].quantity,
              },
            ],
          },
        });

        deleteCallback(listProducts, response.cart.formattedTotal);

        element.classList.remove(classLocked);
      } else {
        // Delete Overlay to element deleted
        productElement.classList.remove('is-awaitDelete');

        if (CartHeaderServices.logSentry) {
          Sentry.captureException(`[EMINZA-DELETE-CART-HEADER] error`);
        } else {
          console.error(`[EMINZA-DELETE-CART-HEADER] error`);
        }
      }
    }
  }

  /*
   * Add product in cart
   * */
  public static addProduct(
    productId: string,
    product: ProductHeaderInterface,
    addCallback: Function
  ) {
    // Ajax
    addCallback(productId, product);
  }
}
